import ProjectCard from "../Cards/ProjectCard";
import { projects } from "../../data/constants";
import {
  CardContainer,
  Container,
  Title,
  Wrapper,
} from "../CommonStyles/CardsContainer";

const Projects = ({ setOpenModalProject }) => {
  return (
    <Container id="projects">
      <Wrapper>
        <Title>Projects</Title>
        <CardContainer>
          {projects
            .map((project, index) => (
              <ProjectCard
                key={index}
                project={project}
                setOpenModalProject={setOpenModalProject}
              />
            ))}
        </CardContainer>
      </Wrapper>
    </Container>
  );
};

export default Projects;
